import { Box, IconButton, InputAdornment, Stack, Typography } from "@mui/material";

import Iconify from "@src/components/iconify";

import { StyledRoot, StyledSearch, StyledWrap } from "@src/sections/@dashboard/styles.css";

import { useServices } from "../hooks";
import { useDrawResultContext } from "../provider";

const Toolbar = () => {
	const { state, handleSearch } = useDrawResultContext();
	const { isLoading, onRefreshPrevious } = useServices();
	const { search } = state || {};

	return (
		<Stack>
			<Box sx={{flexDirection: "row", display: "flex", alignItems: "center", justifyContent: "space-between", fontStyle: "italic", fontSize: 13, color: "#6D7C84"}}>
				<Box sx={{width: 116, height: "1px", bgcolor: "#6D7C84"}} />
				This Previous draw result section won’t be displayed on the Rewards website. It’s only for tracking past winning results.
				<Box sx={{width: 116, height: "1px", bgcolor: "#6D7C84"}} />
			</Box>
			<StyledRoot sx={{
				width: "100%",
				mt: 2,
				height: {
					xl: 96,
					lg: 96,
					md: 96,
					sm: 122,
					xs: 122,
				},
				flexDirection: {
					xl: "row",
					lg: "row",
					md: "row",
					sm: "column",
					xs: "column",
				},
				alignItems: {
					xl: 'center',
					lg: 'center',
					md: 'center',
					sm: 'flex-end',
					xs: 'flex-end',
				}
			}}>
				<Typography display={"inline"} color={"#333B69"} fontSize={19} fontWeight={700}>
					Previous Draw Results
				</Typography>

				<StyledWrap >
					<IconButton aria-label="delete" color="primary" onClick={onRefreshPrevious}>
						<Iconify icon={'mdi:refresh'} width={30} />
					</IconButton>
					<StyledSearch
						disabled={isLoading}
						value={search}
						sx={{
							width: {
								xl: 320,
								lg: 320,
								md: 320,
								sm: "100%",
								xs: "100%",
							},
							'&.Mui-focused': {
								width: {
									xl: 320,
									lg: 320,
									md: 320,
									sm: "100%",
									xs: "100%",
								}
							},
						}}
						onChange={(event) => handleSearch(event.target.value)}
						placeholder="Search..."
						endAdornment={
							<InputAdornment position="start">
								<Iconify
									icon="eva:search-fill"
									sx={{
											color: 'text.disabled',
											width: 20,
											height: 20
									}}
								/>
							</InputAdornment>
						}
					/>
				</StyledWrap>
			</StyledRoot>
		</Stack>
	)
}

export default Toolbar;